import { apiTransformer } from 'utils';

export const secretaryToApiTransformer = values => {
    return apiTransformer(values, ['qualification', 'profile']);
}
